import { Box, FormLabel, Switch } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import React from "react";
import { z } from "zod";
import { useLiveEditConfirmation } from "../../LiveEditConfirmation";
import * as QuestionType from "./QuestionType";

export const FormikSchema = z
  .object({
    requirement: z.union([z.literal("Required"), z.literal("NotRequired")]),
  })
  .and(QuestionType.FormikSchema);
export type FormikType = z.infer<typeof FormikSchema>;

type Props = {
  questionId: uuid;
};
export const RequirementSwitch: React.FC<Props> = ({ questionId }) => {
  const formik = useFormikContext<FormikType>();

  const LiveEditConfirmation = useLiveEditConfirmation();

  const onChangeHandler = React.useCallback(async () => {
    if (formik.values.requirement === "Required") {
      await formik.setFieldValue("requirement", "NotRequired");
    } else {
      if (await LiveEditConfirmation.confirmRequirement()) {
        await formik.setFieldValue("requirement", "Required");
      }
    }
  }, [LiveEditConfirmation, formik]);

  const id = `requirement-${questionId}`;
  return (
    <FormLabel htmlFor={id} display="flex" flexDirection="row" gap="3">
      <Switch
        id={id}
        isChecked={formik.values.requirement === "Required"}
        onChange={onChangeHandler}
      />
      <Box>Required</Box>
    </FormLabel>
  );
};
